export default "/profile/images/NextCRM.svg?6e24993cbd796cfe8308da70f5e8d552";